<template>
  <div class="step-confirm">
    <h2 class="step-confirm__title">Almost done</h2>

    <div class="summary-card">
      <div class="summary-row">
        <span class="summary-icon">🌱</span>
        <span class="summary-name">{{ wizardData.name }}</span>
      </div>
      <div class="summary-row summary-row--sub">
        <span>📍 {{ wizardData.city }}</span>
        <span class="ml-3">{{ expositionLabel }}</span>
      </div>
      <div v-if="wizardData.container_only" class="summary-row summary-row--sub">
        <span>🪴 Container only</span>
      </div>
    </div>

    <div class="compost-section">
      <div class="field-label">Do you have a worm compost bin?</div>
      <v-radio-group
        :value="wizardData.has_worm_compost"
        row
        hide-details
        class="mt-1"
        @change="$emit('update:wizardData', { ...wizardData, has_worm_compost: $event })"
      >
        <v-radio :value="true"  label="Yes, I compost" color="primary" />
        <v-radio :value="false" label="Not yet"        color="primary" />
      </v-radio-group>
    </div>
  </div>
</template>

<script>
const EXPOSITION_LABELS = {
  full_sun: '☀️ Full sun',
  partial:  '🌤 Partial',
  shade:    '🌿 Shade',
}

export default {
  name: 'StepConfirm',
  props: {
    wizardData: { type: Object, required: true },
  },
  computed: {
    expositionLabel() {
      return EXPOSITION_LABELS[this.wizardData.exposition] || ''
    },
  },
}
</script>

<style scoped>
.step-confirm__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a3a2a;
  margin-bottom: 16px;
}
.summary-card {
  border: 1.5px solid #e0e0d8;
  border-radius: 10px;
  padding: 16px;
  background: #fafaf8;
  margin-bottom: 20px;
}
.summary-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 0.95rem;
  color: #333;
}
.summary-row:last-child {
  margin-bottom: 0;
}
.summary-row--sub {
  font-size: 0.85rem;
  color: #666;
}
.summary-icon {
  font-size: 1.2rem;
}
.summary-name {
  font-weight: 600;
  font-size: 1rem;
}
.field-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #444;
  margin-bottom: 4px;
}
</style>
